import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { getSubmissionRevisions } from './../api';
import { downloadQuoteRevisionSubmission } from './../actions';
import { Loading } from '../../components/shared';
import { formatDollars } from '../../utils/utilities';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Download } from 'lucide-react';

class BinderRevisions extends Component {
  state = {
    submission: [],
    selected: {},
    loading: false,
    subid: '',
    revNo: '',
    url: ''
  }
  selectRowProp = {
    mode: 'radio',
    onSelect: this.onRowSelect.bind(this),
  };

  count =0;
  maxHit=3;

  componentDidMount() {
    this.fetchRevisions(0, 3);
  }

  fetchRevisions(currentHit, maxHit) {
    const submissionId = this.props.id;
    if (!!submissionId) {
      if (currentHit >= maxHit) {
        this.setState({ loading: false });
        return;
      }
      this.setState({ loading: true});
      getSubmissionRevisions(this.props.user, { id: submissionId }, false).then((response) => {
        if (response.status === 200) {
          this.setState({
            submission: response.data,
            loading: false
          })
        }
      }).catch((error) => {
        if (error.status) {
          setTimeout(this.fetchRevisions.bind(this, currentHit+1, maxHit), 3000);
        } else {
          this.setState({ loading: false });
        }
      });
    }
  }
  setTableNoDataText() {
    if (this.state.loading) {
      return (
        <div className="binder-revision-loading">
          <Loading width="22px" height="22px" />
        </div>
      )
    } else {
      return 'There is error in displaying data'
    }
  }

  formatDollarsData = cell => formatDollars(cell, 'N/A', true)

  onRowSelect(row, isSelected, e) {
    const selectedRevision = {
      id: row.id,
      revisionNumber: row.revisionNumber,
      isSelected,
      commission: row.commission,
    }
    this.setState(selectedRevision);
    this.props.onSelect(selectedRevision, true);
  }

  getRevisions(submission) {
    if (submission.length === 0) {
      return [];
    }
    const { id, commission, revisions } = submission;
    let key = 0;
    return revisions.filter(revision => !revision.hasOwnProperty('isBinded') && (!revision.ratings.ocp.failedReferralRules || revision.manuallySetPricing === 'true') && (!revision.hasOwnProperty('quoteDrafted') || revision.quoteDrafted === 'false') && revision.transactionStatus !== 'IP').map(revision => {
      let ind = null;
      const { type } = revision;
      const revisionTotalPremium = revision.ratings[type].totalPremium;
      const revisonCommission = revision.hasOwnProperty("adjustedCommission") ? revision.adjustedCommission : commission;
      const revisionDate = revision.createdAt;
      const revisionNumber = revision.revisionNumber;
      if (this.props.savedRevision === revisionNumber) {
        ind = key+1;
        const defaultSelection = {
          id: id,
          revisionNumber: revisionNumber,
          isSelected: true,
          commission: revisonCommission,
        }
        this.props.onSelect(defaultSelection);
      }
      key += 1;
      return {
        totalPremium: revisionTotalPremium,
        commission: revisonCommission,
        date: revisionDate,
        id,
        revisionNumber,
        key,
        ind,
      }

    }).sort((a, b) => new Date(b.date) - new Date(a.date));

  }

  downloadQuote = (event, id, revisionNumber) => {
    this.props.getDownloadQuoteRevisionSubmission(this.props.user, id, revisionNumber)
  }
  handleHidePdf=() => {
    this.setState({
      subid: '',
      revNo: '',
    });
  }

  handlePDFPreview = (id, revisionNumber) => {
    this.props.getDownloadQuoteRevisionSubmission(this.props.user, id, revisionNumber, false);
    this.props.handlepdf(true);
  }

  formatActionColumn = (cell, row) => {
    return (
      <div>
      <Button onClick={(event) => this.downloadQuote(event, row.id, row.revisionNumber)}><Download size={16}/></Button>
      <Button onClick={(event) => this.handlePDFPreview(row.id, row.revisionNumber)} >
      <FontAwesomeIcon icon={faEye} />
      </Button>
      </div>
    )
  }

  formatDateColumn = (cell, row) => {
    const date = new Date(cell);
    return new Intl.DateTimeFormat('en', { day: '2-digit', month: 'short', year: 'numeric', timeZone: 'UTC' }).format(date);
  }

  render() {
    const revisions = this.getRevisions(this.state.submission);

    const retainSaved = revisions.find(cur => cur.ind !== null);

    const selectDefaultProp = {
      mode: 'radio',
      selected: (this.props.savedRevision !== null && this.props.savedRevision !==undefined && !!retainSaved) ? [(parseInt(retainSaved.ind))] : null,
      onSelect: this.onRowSelect.bind(this),
    };

    const tableOptions = {
      noDataText: this.setTableNoDataText.bind(this)
    };

    return (
      <div style={{width: '100%',overflowY:'auto'}}>
      <BootstrapTable data={revisions} maxHeight="140px" selectRow={retainSaved ? selectDefaultProp : this.selectRowProp } scrollTop={'Top'} bodyContainerClass="revision-table-body" options={tableOptions}>
        <TableHeaderColumn dataAlign="center" dataField="totalPremium" dataFormat={this.formatDollarsData}>Total Premium</TableHeaderColumn>
        <TableHeaderColumn dataAlign="center" dataField="commission">Commission %</TableHeaderColumn>
        <TableHeaderColumn dataAlign="center" dataField="date" dataFormat={this.formatDateColumn}>Date Quoted</TableHeaderColumn>
        <TableHeaderColumn isKey dataAlign="center" dataField="key" dataFormat={this.formatActionColumn}>Download</TableHeaderColumn>
      </BootstrapTable>
      </div>

    )
  }
}
const mapStateToProps = state => {
  return {
      PDFdata: state.app.PDFdata
  };
};

export const getDownloadQuoteRevisionSubmission = (dispatch, user, submissionID, revisionNumber, flag) => {
  dispatch(downloadQuoteRevisionSubmission(user, submissionID, revisionNumber, null, flag));
};

export const mapDispatchToProps = dispatch => ({
  getDownloadQuoteRevisionSubmission: (user, submissionID, revisionNumber, flag) => getDownloadQuoteRevisionSubmission(dispatch, user, submissionID, revisionNumber, flag),
});

export default connect(mapStateToProps, mapDispatchToProps)(BinderRevisions)
